import React, { useState } from "react";
import { Button, Pagination, Table } from "antd";
import moment from "moment";

import { ContentLoader } from "@components";
import { i18, trb } from "@utilities";
import { CONFIGS } from "@config/Applications";
import useAppConfigControl from "@hooks/useAppConfigControl";
import { RiskSettingsTableFilter } from "../Util/RiskSettingsTableFilter";
import { EditRisk } from "../Modals/EditRisk";

import "./RisksSettingsTab.less";

const INITIAL_FILTER_VALUES = {
  riskDescription: "",
  isActual: true,
  page: 1,
  rowsPerPage: 20
};

export const RisksSettingsTab = React.memo(() => {
  const {
    onFilter,
    onPageChange,
    tableFilters: riskFilters,
    config: risksConfig,
    isLoading,
    downloadExcel,
    isDownloadingExcel
  } = useAppConfigControl({
    initialFilters: INITIAL_FILTER_VALUES,
    configKey: CONFIGS.RISKS
  });

  const [hoveredRisk, setHoveredRisk] = useState();
  const [selectedRisk, setSelectedRisk] = useState();

  if (isLoading) {
    return <ContentLoader />;
  }

  const risksColumn = [
    {
      title: trb(i18.ApplicationsLabels.RiskSettingsDescriptionCol),
      dataIndex: "riskDescription",
      key: "riskDescription"
    },
    {
      title: trb(i18.ApplicationsLabels.RiskSettingsTypeCol),
      dataIndex: "riskType",
      key: "riskType"
    },
    {
      title: trb(i18.ApplicationsLabels.RiskSettingsScoreCol),
      dataIndex: "riskScore",
      key: "riskScore"
    },
    {
      title: trb(i18.ApplicationsLabels.RiskSettingsIsActiveCol),
      dataIndex: "isActive",
      key: "isActive",
      render: item =>
        item
          ? trb(i18.ApplicationsLabels.RiskSettingsIsActiveTrue)
          : trb(i18.ApplicationsLabels.RiskSettingsIsActiveFalse)
    },
    {
      title: trb(i18.ApplicationsLabels.RiskSettingsIsAutomaticCol),
      dataIndex: "isAutomatic",
      key: "isAutomatic",
      render: item =>
        item
          ? trb(i18.ApplicationsLabels.RiskSettingsIsAutomaticTrue)
          : trb(i18.ApplicationsLabels.RiskSettingsIsAutomaticFalse)
    },
    {
      title: trb(i18.ApplicationsLabels.RiskSettingsCreatedCol),
      dataIndex: "created",
      key: "created",
      render: item => item && moment(item).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: trb(i18.ApplicationsLabels.RiskSettingsDeletedDateCol),
      dataIndex: "deletedDate",
      key: "deletedDate",
      render: item => item && moment(item).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      key: "action",
      render: row => {
        if (row.id !== hoveredRisk) return <div className="btn-placeholder" />;
        return (
          <Button onClick={() => setSelectedRisk(row)} type="primary">
            {trb(i18.Buttons.Edit)}
          </Button>
        );
      }
    }
  ];

  return (
    <>
      <div className="risks-settings-tab">
        <RiskSettingsTableFilter
          onFilter={onFilter}
          filterValues={riskFilters}
          handleDownload={downloadExcel}
          isDownloadingExcel={isDownloadingExcel}
        />
        <Table
          className="w-100 mb-3"
          dataSource={risksConfig.items}
          columns={risksColumn}
          scroll={{ x: "60vw" }}
          pagination={false}
          rowKey="id"
          size="middle"
          onRow={record => {
            return {
              onMouseEnter: () => setHoveredRisk(record.id),
              onMouseLeave: () => setHoveredRisk(undefined)
            };
          }}
        />
        <div className="text-right">
          <Pagination
            showSizeChanger
            pageSize={riskFilters.rowsPerPage}
            current={riskFilters.page}
            onChange={onPageChange}
            defaultCurrent={1}
            total={risksConfig.paging.totalItems}
          />
        </div>
      </div>
      {selectedRisk && (
        <EditRisk onClose={() => setSelectedRisk(undefined)} riskConfig={selectedRisk} />
      )}
    </>
  );
});
